import gql from 'graphql-tag'

export const QUERY_GET_USERS = gql`
  query Users($search: String, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection], $searchMode: String) {
    users(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection, searchMode: $searchMode) {
      records
      page
      users {
        _id
        document_no
        name
        phone
        email
        state_registration
        gender
        birth_date
        last_accepted_terms_date
        origin
        points {
          total
        }
        created_at
        address {
          id
          postal_code
          street
          number
          neighborhood
          city
          city_name
          federative_unit
          complement
        }
        is_confirmed
        confirmed_at
        confirmation_sent_at
      }
    }
  }
`

export const QUERY_CHECK_AVAILABLE_EMAIL = gql`
  query CheckAvailableUserEmail($email: String!) {
    checkAvailableUserEmail(email: $email)
  }
`

export const QUERY_GET_POINTS_TRANSACTIONS = gql`
  query PointsTransactions($userDocumentNo: ID, $page: Int, $pageSize: Int) {
    pointsTransactions(userDocumentNo: $userDocumentNo, page: $page, pageSize: $pageSize) {
      records
      page
      pointsTransactions {
        amount
        type
        unit {
          name
        }
        created_at
      }
    }
  }
`

export const QUERY_GET_LOGS = gql`
  query OperationLogs($fieldFilters: [FieldFilter], $page: Int, $pageSize: Int, $mutation: String) {
    operationLogs(fieldFilters: $fieldFilters, page: $page, pageSize: $pageSize, mutation: $mutation) {
      records
      page
      operationLogs {
        mutation
        delta {
          field
          description
          old {
            value
          }
          new {
            value
          }
        }
        user {
          login
        }
        created_at
      }
    }
  }
`

export const QUERY_GET_USERS_PENDING_DELETE_DATA_REQUEST = gql`
  query UsersPendingDeleteDataRequest($search: String, $page: Int!, $pageSize: Int!, $sort: [String], $sortDirection: [SortDirection]) {
    usersPendingDeleteDataRequest(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      usersPendingDeleteDataRequest {
        _id
        document_no
        name
        pending_delete_data_request {
          data
          requested_at
        }
      }
    }
  }
`

export const QUERY_GET_USERS_ALL_DELETE_DATA_REQUESTS = gql`
  query UsersAllDeleteDataRequests($search: String, $page: Int!, $pageSize: Int!, $sort: [String], $sortDirection: [SortDirection]) {
    usersAllDeleteDataRequests(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      usersAllDeleteDataRequests {
        _id
        document_no
        name
        delete_data_request {
          _id
          data
          requested_at
          finished_at
          status
          finished_by
          reply
        }
      }
    }
  }
`

export const QUERY_GET_TOTAL_USERS_PENDING_DELETE_DATA_REQUEST = gql`
  query UsersPendingDeleteDataRequest($page: Int!, $pageSize: Int!) {
    usersPendingDeleteDataRequest(page: $page, pageSize: $pageSize) {
      records
    }
  }
`

export const QUERY_STANDARD_USER_REPLIES = gql`
  query StandardUserReplies($user_id: ID!, $type: StandardUserReplyType) {
    standardUserReplies(user_id: $user_id, type: $type) {
      _id
      title
      text
      type
    }
  }
`

export const QUERY_GET_DELETE_USER_REQUESTS = gql`
  query DeleteUserRequests($page: Int!, $pageSize: Int!, $sort: [String], $sortDirection: [SortDirection]) {
    deleteUserRequests(page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      deleteUserRequests {
        _id
        requested_at
        finished_at
        finished_by
      }
    }
  }
`

export const MUTATION_CHANGE_PASSWORD = gql`
  mutation ChangeUserPassword($_id: ID!, $password: String!) {
    changeUserPassword(_id: $_id, password: $password)
  }
`

export const MUTATION_RESEND_SIGN_UP_CONFIRMATION = gql`
  mutation ResendSignUpConfirmation($input: ResendSignUpConfirmationInput!) {
    resendSignUpConfirmation(input: $input) {
      sent
      errorMessage
    }
  }
`

export const MUTATION_SIGN_UP_CONFIRMATION_MANUALLY = gql`
  mutation SignUpConfirmationManually($consumerId: String!) {
    signUpConfirmationManually(consumerId: $consumerId) {
      messageError
      wasConfirmated
    }
  }
`

export const MUTATION_EDIT_USER = gql`
  mutation UpdateUser($user: UpdateUserInput!) {
    updateUser(user: $user)
  }
`

export const MUTATION_ADJUST_POINTS = gql`
  mutation AdjustPoints($userId: ID!, $pointsAdjustment: Int!) {
    adjustPoints(userId: $userId, pointsAdjustment: $pointsAdjustment) {
      success
      error
    }
  }
`

export const MUTATION_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($_id: String!, $email: String!) {
    requestPasswordReset(_id: $_id, email: $email)
  }
`

export const MUTATION_ACCEPT_USER_DELETE_DATA_REQUEST = gql`
  mutation AcceptUserDeleteDataRequest($users_id: [String!]!) {
    acceptUserDeleteDataRequest(users_id: $users_id) {
      requestWasModified
      records
    }
  }
`

export const MUTATION_DECLINE_USER_DELETE_DATA_REQUEST = gql`
  mutation DeclineUserDeleteDataRequest($user_id: String!, $trigger_email: Boolean!, $reply: String!) {
    declineUserDeleteDataRequest(user_id: $user_id, trigger_email: $trigger_email, reply: $reply) {
      requestWasModified
      records
    }
  }
`
export const ACCOUNT_OR_FRANCHISE_HOTSITE_SIGNUP_CONFIGURATION_INPUT = gql`
  query AccountOrFranchiseHotsiteConfiguration {
    hotsiteConfiguration {
      configuration {
        facebook_pixel_id
        google_analytics_id
        allowed_countries
        fields {
          natural {
            type
            name
            validators
            visible
            mandatory
          }
          legal {
            type
            name
            validators
            visible
            mandatory
          }
        }
      }
    }
  }
`
